// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3XKQe","title":"Images45_title__1ZO8S","images":"Images45_images__Kvwbx"};